import axios from "axios";
import React, { useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import "../../workers/WorkerCategories.css"
import Swal from "sweetalert2";
import profileIcon from "../../../../assets/img/icons/vecteezy_man-empty-avatar-vector-photo-placeholder-for-social_36594092.jpg"
import "../../workers/Workers.css";
import Checkbox from "src/components/layout/Checkbox";
import LoadingGif from "src/components/layout/Loader";
import { startLoading, stopLoading } from "src/store/loading/loadingSlice";
import { ECategory, ICategory, ISubCategory } from "src/helper/interfaces";
import Cookies from "js-cookie";
import placeholderImg from "../../../../assets/img/landscape-placeholder-svgrepo-com.svg";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { formatCategory } from "src/utils/normalFuntions";
import edit from "../../../../assets/img/icons/icons8-edit.svg";

import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import { Link, useNavigate, useParams } from "react-router-dom";
import { getAllCategories, getSubCatByCatId } from "../../workers/Workers";

interface InitialValuesType {
   _id: string;
   phone: string;
   otp: string;
   has_membership: boolean;
   has_subscription: boolean;
   has_firm: boolean;
   is_activated_account: boolean;
   is_basic_details_completed: boolean;
   // is_deleted: boolean;
   is_document_details_completed: boolean;
   is_membership_details_completed: boolean;
   is_online: boolean;
   is_otp_verified: boolean;
   is_question_ans_completed: boolean;
   is_verified: boolean;
   // otp: number;
   createdAt: string;
   // role: 'worker' | 'other_roles_if_any'; // Extend roles as needed
   specification: string[];
   // updatedAt: string;
   you_are_a: string[];
   your_work: string[]; // Array of URLs
   country: string;
   state: string;
   city: string;
   lat: number;
   long: number;
   street: string;
   landmark: string;
   pin_code: string;
   dial_code: string;
   alternate_number: string;
   bio: string;
   date_of_birth: string; // Date string
   gender: 'Male' | 'Female' | 'Other'; // Extend genders as needed
   name: string;
   profile_pic: string | null; // URL string
   qualification: string;
   referral_code: string;
   my_referral: string;
   sub_worker_type: string[];
   worker_type: string;
   // bank_details: {
   account_holder_name: string;
   bank_name: string;
   account_number: string;
   IFSC_code: string;

   // };
   // document_details: {
   worker_specialization: string[];
   type_of_business: string;
   adhaar_number: string;
   pan_number: string;
   adhaar_front_pic: string; // URL string
   adhaar_back_pic: string; // URL string
   category: string,
   firm_age: string;
   firm_gst_number: string;
   firm_pan_number: string;
   firm_gst_pic: string;
   firm_pan_pic: string;
   seller_shop_pic1: string;
   seller_shop_pic2: string;
   pan_front_pic: string;
   more_areas_served: string;
   firm_name: string;
   walletAmount: number;
   // };
}

const getWorkerById = async (token: string, id: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/worker/${id}`, {
      headers: {
         "x-access-token": token
      }
   });
}


interface ISubCatAndSpecsData {
   sub_categories: ISubCategory[],
   specificaions: ISubCategory[]
}

const youAreArray = [
   "Manufacturer",
   "Distributor",
   "Authorized Dealer"
];

const typeOfBusiness = [
   "Wholesale",
   "Retail"
];

const WorkerEditPage = () => {

   const initialValues: InitialValuesType = {
      _id: "",
      phone: "",
      has_firm: false,
      has_membership: false,
      has_subscription: false,
      is_activated_account: false,
      is_basic_details_completed: false,
      is_document_details_completed: false,
      is_membership_details_completed: false,
      is_online: false,
      is_otp_verified: false,
      is_question_ans_completed: false,
      is_verified: false,
      specification: [],
      you_are_a: [],
      your_work: [],
      country: "",
      state: "",
      city: "",
      dial_code: "",
      lat: 0.0,
      long: 0.0,
      otp: "",
      pin_code: "",
      street: "",
      landmark: "",
      alternate_number: "",
      bio: "",
      date_of_birth: "",
      gender: "Other",
      name: "",
      account_holder_name: "",
      bank_name: "",
      account_number: "",
      IFSC_code: "",
      profile_pic: null,
      qualification: "",
      referral_code: "",
      my_referral: "",
      createdAt: "",
      sub_worker_type: [],
      worker_type: "",
      worker_specialization: [],
      adhaar_number: "",
      pan_number: "",
      adhaar_front_pic: "",
      adhaar_back_pic: "",
      category: "",
      firm_age: "",
      firm_gst_number: "",
      firm_pan_number: "",
      firm_gst_pic: "",
      firm_pan_pic: "",
      seller_shop_pic1: "",
      seller_shop_pic2: "",
      pan_front_pic: "",
      more_areas_served: "",
      firm_name: "",
      walletAmount: 0,
      type_of_business: ""

   };
   const { id } = useParams();
   const navigate = useNavigate();
   const dispatch = useAppDispatch();
   const [selectedWorker, setSelectedWorker] = useState(initialValues);
   const [show, setShow] = useState({
      edit: false,
      view: false
   });
   const [workerProfessionalSpecs, setWorkerProfessionalSpecs] = useState([]); // Store Worker Professional specs
   const [subCatData, setSubCatData] = useState<ISubCatAndSpecsData>({
      sub_categories: [],
      specificaions: []
   });

   const [categories, setCategories] = useState<ICategory[]>([]);
   const loading = useAppSelector(state => state.loading.value);
   const Token = Cookies.get("token");

   const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const { name, value } = event.target;

      setSelectedWorker({ ...selectedWorker, [name]: value });
   }

   useEffect(() => {
      // console.log("id: ", id);
      if (!Token) return;

      getWorkerById(Token as string, id as string)
         .then((res) => {
            if (res?.data?.status_code === 200) {
               const worker = res?.data?.data;

               // Set selectedWorker
               setSelectedWorker({
                  ...selectedWorker,
                  _id: worker?._id,
                  name: worker?.name,
                  phone: worker?.phone,
                  has_firm: worker?.has_firm,
                  sub_worker_type: worker?.sub_worker_type,
                  worker_type: worker?.worker_type,
                  alternate_number: worker?.alternate_number,
                  bio: worker?.bio,
                  date_of_birth: worker?.date_of_birth,
                  dial_code: selectedWorker?.dial_code,
                  gender: worker?.gender,
                  profile_pic: worker?.profile_pic as string,
                  qualification: worker?.qualification,
                  referral_code: worker?.referral_code,
                  otp: worker?.otp,
                  createdAt: worker?.createdAt,
                  my_referral: worker?.my_referral,
                  walletAmount: worker?.walletAmount,
                  is_otp_verified: worker?.is_otp_verified,
                  is_basic_details_completed: worker?.is_basic_details_completed,
                  is_verified: worker?.is_verified,
                  is_activated_account: worker?.is_activated_account,
                  is_document_details_completed: worker?.is_document_details_completed,
                  is_membership_details_completed: worker?.is_membership_details_completed,
                  is_online: worker?.is_online,
                  is_question_ans_completed: worker?.is_question_ans_completed,
                  has_membership: worker?.has_membership,
                  has_subscription: worker?.has_subscription,
                  country: worker?.address?.country,
                  state: worker?.address?.state,
                  city: worker?.address?.city,
                  lat: worker?.address?.lat,
                  long: worker?.address?.long,
                  pin_code: worker?.address?.pin_code,
                  street: worker?.address?.street as string,
                  landmark: worker?.address?.landmark as string,
                  specification: worker?.specification,
                  you_are_a: worker?.you_are_a,
                  your_work: worker?.your_work,
                  account_holder_name: worker?.bank_details?.account_holder_name,
                  bank_name: worker?.bank_details?.bank_name,
                  account_number: worker?.bank_details?.account_number,
                  IFSC_code: worker?.bank_details?.IFSC_code,
                  worker_specialization: worker?.document_details?.worker_specialization,
                  adhaar_number: worker?.document_details?.adhaar_number,
                  pan_number: worker?.document_details?.pan_number,
                  adhaar_front_pic: worker?.document_details?.adhaar_front_pic,
                  adhaar_back_pic: worker?.document_details?.adhaar_back_pic,
                  firm_age: worker?.document_details?.firm_age,
                  firm_name: worker?.firm_name,
                  firm_gst_number: worker?.document_details?.firm_gst_number,
                  firm_pan_number: worker?.document_details?.firm_pan_number,
                  firm_gst_pic: worker?.document_details?.firm_gst_pic,
                  firm_pan_pic: worker?.document_details?.firm_pan_pic,
                  seller_shop_pic1: worker?.document_details?.seller_shop_pic1,
                  seller_shop_pic2: worker?.document_details?.seller_shop_pic2,
                  pan_front_pic: worker?.document_details?.pan_front_pic,
                  more_areas_served: worker?.document_details?.more_areas_served,
                  type_of_business: worker?.type_of_business
               });

               // Fetch categories
               getAllCategories(Token)
                  .then((res) => {
                     setCategories(res?.data?.data);
                  })
                  .catch((err) => {
                     console.error(err);
                  });
            }
         })
         .catch((err: any) => {
            console.error(err);
         });
   }, [id]);

   // useEffect(() => {
   //    const inputElement = document.querySelector<HTMLInputElement>("#phone");

   //    if (inputElement) {
   //       const valueLength = inputElement.value.length;
   //       console.log(valueLength);

   //    }
   // }, [selectedWorker?.phone])

   const handlePhone = (e: React.ChangeEvent<HTMLInputElement>, type?: string) => {
      let newPhone = e?.target?.value;

      if (newPhone.length > 10) {
         newPhone = newPhone?.slice(0, 10)
      };
      if (type === "alt_number") {
         setSelectedWorker({
            ...selectedWorker,
            alternate_number: newPhone
         });
      } else {
         setSelectedWorker({
            ...selectedWorker,
            phone: newPhone
         });
      }

   }

   useEffect(() => {
      if (Token) {
         getSubCatByCatId(Token, ECategory?.WORKER_PROFESSIONAL)
            .then((res) => {
               const data = res?.data?.data;
               console.log("Worker Professional Specs: ", data);

               // Save worker professional specifications separately
               setWorkerProfessionalSpecs(data?.specifications ?? []);
            })
            .catch((err) => {
               console.error(err);
            });
      }
   }, []);

   // New useEffect to watch for changes to selectedWorker
   useEffect(() => {
      if (selectedWorker?.worker_type && Token) {
         getSubCatByCatId(Token, selectedWorker.worker_type)
            .then((res) => {
               const data = res?.data?.data;
               console.log("subCats: ", data);

               setSubCatData({
                  ...subCatData,
                  sub_categories: data?.sub_categories ?? [],
                  specificaions: selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM
                     ? workerProfessionalSpecs // Use stored Worker Professional specs
                     : data?.specifications ?? []
               });
            })
            .catch((err) => {
               console.error(err);
            });
      }
   }, [selectedWorker?.worker_type, workerProfessionalSpecs]); // Re-run when worker type changes or Worker Professional specs are updated

   const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
      // console.log(formInput);
      event.preventDefault();
      const formData = new FormData();
      // console.log(inputs);
      formData.append('name', selectedWorker?.name ?? "");
      formData.append('phone', selectedWorker?.phone ?? "");
      formData.append('has_membership', selectedWorker?.has_membership?.toString() ?? false);
      formData.append('is_activated_account', selectedWorker?.is_activated_account.toString() ?? "");
      formData.append('is_basic_details_completed', selectedWorker?.is_basic_details_completed?.toString() ?? false);
      formData.append('is_document_details_completed', selectedWorker?.is_document_details_completed.toString() ?? false);
      formData.append('is_membership_details_completed', selectedWorker?.is_membership_details_completed.toString() ?? false);
      formData.append('is_online', selectedWorker?.is_online.toString() ?? false);
      formData.append('is_otp_verified', selectedWorker?.is_otp_verified.toString() ?? false);
      formData.append('is_question_ans_completed', selectedWorker?.is_question_ans_completed.toString() ?? false);
      formData.append('is_verified', selectedWorker?.is_verified.toString() ?? false);
      formData.append('firm_name', selectedWorker?.firm_name ?? "");
      formData.append("you_are_a", selectedWorker?.you_are_a?.join(",") ?? [])
      formData.append("type_of_business", selectedWorker?.type_of_business ?? "")
      Object.values(selectedWorker?.specification).map((data, key) => {
         formData.append('specification', data);
      });
      Object.values(selectedWorker?.worker_specialization).map((data, key) => {
         formData.append('worker_specialization', data);
      });
      Object.values(selectedWorker?.sub_worker_type).map((data, key) => {
         formData.append('sub_worker_type', data);
      });


      // formData.append("specification", selectedWorker?.specification?.join(","))
      // formData.append('sub_worker_type', selectedWorker?.sub_worker_type?.join(",") ?? []);
      formData.append('worker_type', selectedWorker?.worker_type ?? "");
      formData.append('alternate_number', selectedWorker?.alternate_number ?? "");
      formData.append('date_of_birth', selectedWorker?.date_of_birth ?? "");
      formData.append('bio', selectedWorker?.bio ?? "");
      formData.append('dial_code', selectedWorker?.dial_code ?? "");
      formData.append('qualification', selectedWorker?.qualification ?? "");
      formData.append('gender', selectedWorker?.gender ?? "");
      // formData.append('gender', selectedWorker?.gender ?? "");
      // formData.append('gender', selectedWorker?.gender ?? "");


      formData.append('country', selectedWorker?.country ?? "");
      formData.append('state', selectedWorker?.state ?? "");
      formData.append('city', selectedWorker?.city ?? "");
      formData.append('lat', selectedWorker?.lat?.toString() ?? 0);
      formData.append('long', selectedWorker?.long?.toString() ?? 0);
      formData.append('pin_code', selectedWorker?.pin_code ?? "");
      formData.append('street', selectedWorker?.street ?? "");

      formData.append('landmark', selectedWorker?.landmark ?? "");

      // bank details

      formData.append('account_holder_name', selectedWorker?.account_holder_name ?? "");
      formData.append('bank_name', selectedWorker?.bank_name ?? "");
      formData.append('account_number', selectedWorker?.account_number ?? "");
      formData.append('IFSC_code', selectedWorker?.IFSC_code ?? "");


      formData.append('adhaar_number', selectedWorker?.adhaar_number ?? "");
      formData.append('pan_number', selectedWorker?.pan_number ?? "");
      formData.append('firm_age', selectedWorker?.firm_age ?? "");
      formData.append('firm_gst_number', selectedWorker?.firm_gst_number ?? "");
      formData.append('firm_pan_number', selectedWorker?.firm_pan_number ?? "");
      formData.append('more_areas_served', selectedWorker?.more_areas_served ?? "");


      // console.log(selectedWorker?.profile_pic)
      if (selectedWorker.profile_pic) formData.append('profile_pic', selectedWorker.profile_pic);

      if (selectedWorker?.adhaar_back_pic) formData.append('adhaar_back_pic', selectedWorker.adhaar_back_pic);
      if (selectedWorker?.adhaar_front_pic) formData.append('adhaar_front_pic', selectedWorker.adhaar_front_pic);
      if (selectedWorker?.pan_front_pic) formData.append('pan_front_pic', selectedWorker.pan_front_pic);
      if (selectedWorker?.firm_gst_pic) formData.append('firm_gst_pic', selectedWorker.firm_gst_pic);
      if (selectedWorker?.firm_pan_pic) formData.append('firm_pan_pic', selectedWorker.firm_pan_pic);

      if (selectedWorker?.seller_shop_pic1) formData.append('seller_shop_pic1', selectedWorker.seller_shop_pic1);
      if (selectedWorker?.seller_shop_pic2) formData.append('seller_shop_pic2', selectedWorker.seller_shop_pic2);

      if (!Token) return;

      postData(formData)

   }

   const postData = async (data: FormData) => {
      try {
         // console.log("postData")
         await axios.put(`${AppConfig.DEV_SERVER}/workers-details/${selectedWorker?._id}`, data, {
            headers: {

               'content-type': 'multipart/form-data',
               "X-Access-Token": Token
            },

         }).then((res) => {
            // console.log("res: ", res?.data)
            if (res?.data?.status_code === 200) {
               setTimeout(() => {
                  // setLoading(false);
                  dispatch(stopLoading());

                  // setModalShow(false);
                  setShow({
                     ...show,
                     edit: false
                  })
                  Swal.fire({
                     position: "center",
                     icon: "success",
                     text: "Updated Worker Details.",
                     title: res?.data?.msg,
                     showConfirmButton: false,
                     timer: 2500
                  })
                  navigate(-1);
               }, 1000 * 2)


            }
            else {
               console.log("err")
               Swal.fire({
                  position: "center",
                  icon: "error",
                  text: `${res?.data?.msg}`,
                  title: "Something Went Wrong!",
                  showConfirmButton: false,
                  timer: 3500
               });
               dispatch(stopLoading());
            }


         })

         // console.log('Response data:', response.data);
      } catch (error: any) {
         console.error('Error making POST request:', error.response ? error.response.data : error.message);
      }
   };

   const handleDropdownChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
      const value = event.target.value as "Male" | "Female" | "Other";
      setSelectedWorker({ ...selectedWorker, gender: value });

      // console.log(value);
   };

   const handleCatDropdown = (event: React.ChangeEvent<HTMLSelectElement>) => {
      const value = event.target.value;
      const convert = value?.toLocaleLowerCase().split(" ")?.join("_")
      // console.log("value: ", typeof convert)
      setSelectedWorker({
         ...selectedWorker,
         specification: [],
         sub_worker_type: [],
         worker_specialization: [],
         you_are_a: [],
         worker_type: convert
      })
   };

   const handleYouAreA = (event: React.ChangeEvent<HTMLSelectElement>, type: string) => {
      const value = event.target.value;
      // console.log(value)
      if (type === "you_are_a") {
         setSelectedWorker({ ...selectedWorker, you_are_a: [value] });
      } else {

         setSelectedWorker({ ...selectedWorker, type_of_business: value });
      }

      // console.log("value: ", value)
   }

   const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const { name, files } = event.target;

      if (files && files.length !== 0) {
         setSelectedWorker((prevWorker) => ({
            ...prevWorker,
            [name]: files[0], // or append to an array if handling multiple files per input
         }));
      }
   };

   const animatedComponents = makeAnimated();
   const noSubCat = [ECategory?.SELLER, ECategory.ARCHITECT, ECategory?.WORKER_PROFESSIONAL]

   // useEffect(() => {
   //    console.log(selectedWorker)
   // }, [id])

   return (
      <MainLayout showAllFilters={true}>
         <div className='d-flex justify-content-end '>
            <Link to={selectedWorker?.has_membership ? `/workers/${selectedWorker?._id}` : "#"}
               style={{ pointerEvents: selectedWorker?.has_membership ? "auto" : "none", marginRight: "10px", borderRadius: "20px" }} className="pe-3 p-emd-4 ">
               <button
                  className={`py-2 px-3 text-dark font-weight-normal  ${selectedWorker?.has_membership ? "hover-effect" : ''}`}>
                  View Profile
               </button>
            </Link>

         </div>
         <div className=" main-div">

            <div className={`category-main me-2 p-3 p-md-4 card`} >
               <form onSubmit={handleFormSubmit} className="position-relative">
                  <div className="row">

                     <div className="inputs mb-2 col-12 col-sm-6 col-md-4">
                        <div className=" d-flex flex-column align-items-start gap-2 ">
                           <label htmlFor="servicetitle">Name</label>
                           <input value={selectedWorker?.name} onChange={handleChange} type="text" name="name" id="serviceTitle" aria-describedby="servicetitle" />
                        </div>
                     </div>

                     <div className="inputs mb-2 col-12 col-sm-6 col-md-4">
                        <div className="d-flex flex-column align-items-start gap-2 ">
                           <label htmlFor="phone">Phone</label>
                           <input value={selectedWorker?.phone} onChange={handlePhone} type="number" name="phone" id="phone" />
                        </div>
                     </div>
                     <div className="col-12 col-sm-6 col-md-4 mb-2 d-flex flex-column align-items-start gap-2 inputs">
                        <label htmlFor="gender">Gender</label>
                        <select
                           name="gender"
                           value={selectedWorker?.gender}
                           onChange={handleDropdownChange}
                        >
                           <option value="" disabled>Select Gender</option>
                           <option value="Male">Male</option>
                           <option value="Female">Female</option>
                           <option value="Other">Other</option>
                        </select>
                     </div>
                     <div className="inputs mb-2 col-12 col-sm-6 col-md-4">
                        <div className="d-flex flex-column align-items-start gap-2 ">
                           <label htmlFor="worker_type">Worker Type</label>
                           <select
                              name="worker_type"
                              value={formatCategory(selectedWorker?.worker_type)}
                              onChange={handleCatDropdown}
                              required
                           >
                              {categories && categories.map((value, index) => (
                                 <option key={index} value={value.category_name}>
                                    {value.category_name}
                                 </option>
                              ))}
                           </select>

                        </div>
                     </div>

                     {
                        !noSubCat?.includes(selectedWorker?.worker_type as ECategory) ?
                           <div className="inputs mb-2 col-12 col-sm-6 col-md-4">
                              <div className="d-flex flex-column align-items-start gap-2 ">
                                 <label htmlFor="sub_worker_type">Sub Worker Type</label>

                                 <Select
                                    className="slect-div"
                                    closeMenuOnSelect={false}
                                    components={animatedComponents}
                                    value={
                                       selectedWorker?.sub_worker_type?.map((spec) => ({
                                          label: spec,
                                          value: spec,
                                       })) || []
                                    }
                                    isMulti
                                    onChange={(selectedOptions) => {
                                       const setValues = selectedOptions.map((data) => data?.value);
                                       setSelectedWorker({
                                          ...selectedWorker,
                                          sub_worker_type: setValues,
                                       });
                                    }}
                                    options={subCatData?.sub_categories?.map((data) => ({
                                       label: data?.sub_category_name,
                                       value: data?.sub_category_name,
                                    }))}
                                 />
                              </div>
                           </div>
                           : ""
                     }
                     {
                        selectedWorker?.worker_type !== ECategory.SALES_PROFESSIONAL ?
                           <div className="inputs mb-2 col-12 col-sm-6 col-md-4">
                              <div className="d-flex flex-column align-items-start gap-2">
                                 <label htmlFor="sub_worker_type">Specifications</label>
                                 <Select
                                    className="slect-div"
                                    closeMenuOnSelect={false}
                                    components={animatedComponents}
                                    value={
                                       selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM ?
                                          Array.isArray(selectedWorker?.worker_specialization)
                                             ? selectedWorker.worker_specialization.map((spec) => ({
                                                label: spec,
                                                value: spec,
                                             }))
                                             : [] :
                                          Array.isArray(selectedWorker?.specification)
                                             ? selectedWorker.specification.map((spec) => ({
                                                label: spec,
                                                value: spec,
                                             }))
                                             : []
                                    }

                                    isMulti
                                    onChange={(selectedOptions) => {
                                       const setValues = selectedOptions.map((data) => data?.value);
                                       console.log(setValues);
                                       if (selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM) {
                                          setSelectedWorker({
                                             ...selectedWorker,
                                             worker_specialization: setValues
                                          });
                                       } else {
                                          setSelectedWorker({
                                             ...selectedWorker,
                                             specification: setValues,
                                          });
                                       }

                                    }}
                                    options={subCatData?.specificaions?.map((data) => ({
                                       label: data?.sub_category_name,
                                       value: data?.sub_category_name,
                                    }))}
                                 />
                              </div>
                           </div>

                           : ""
                     }

                     {
                        selectedWorker?.worker_type === ECategory.SELLER ?
                           <>
                              <div className="inputs mb-2 col-12 col-sm-6 col-md-4">
                                 <div className="d-flex flex-column align-items-start gap-2 ">
                                    <label htmlFor="you_are_a">You are a</label>
                                    {/* <input value={selectedWorker?.you_are_a} onChange={handleChange} type="text" name="you_are_a" id="you_are_a" /> */}
                                    <select
                                       name="sub_worker_type"
                                       value={selectedWorker?.you_are_a}
                                       onChange={(e) => handleYouAreA(e, "you_are_a")}
                                       required
                                    >
                                       {youAreArray?.map((value, index) => (
                                          <option key={index} value={value}>
                                             {value}
                                          </option>
                                       ))}
                                    </select>
                                 </div>
                              </div>
                              <div className="inputs mb-2 col-12 col-sm-6 col-md-4">
                                 <div className="d-flex flex-column align-items-start gap-2 ">
                                    <label htmlFor="type_of_business">Type Of Business </label>
                                    {/* <input value={selectedWorker?.you_are_a} onChange={handleChange} type="text" name="you_are_a" id="you_are_a" /> */}
                                    <select
                                       name="sub_worker_type"
                                       value={selectedWorker?.type_of_business}
                                       onChange={(e) => handleYouAreA(e, "type_of_business")}
                                       required
                                    >
                                       {typeOfBusiness?.map((value, index) => (
                                          <option key={index} value={value}>
                                             {value}
                                          </option>
                                       ))}
                                    </select>
                                 </div>
                              </div>
                           </>

                           : ""
                     }
                     {
                        (selectedWorker?.worker_type !== ECategory?.BUSINESS_FIRM && selectedWorker?.worker_type !== ECategory?.SELLER) ?
                           <>
                              <div className="inputs mb-2 col-12 col-sm-6 col-md-4">
                                 <div className="d-flex flex-column align-items-start gap-2 ">
                                    <label htmlFor="qualification">Qualification</label>
                                    <input value={selectedWorker?.qualification} onChange={handleChange} type="text" name="qualification" id="qualification" />
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-4 mb-2 d-flex flex-column align-items-start gap-2 inputs">
                                 <label htmlFor="date_of_birth">Dob</label>
                                 <input value={selectedWorker?.date_of_birth} name="date_of_birth" onChange={handleChange} id="date_of_birth" />
                              </div>
                           </>

                           : ""
                     }


                     <div className="col-12 col-sm-6 col-md-4 mb-2 d-flex flex-column align-items-start gap-2 inputs">
                        <label htmlFor="country">Country</label>
                        <input value={selectedWorker?.country} name="country" onChange={handleChange} id="country" readOnly />
                     </div>
                     <div className="col-12 col-sm-6 col-md-4 mb-2 d-flex flex-column align-items-start gap-2 inputs">
                        <label htmlFor="state">State</label>
                        <input value={selectedWorker?.state} name="state" onChange={handleChange} id="state" />
                     </div>
                     <div className="col-12 col-sm-6 col-md-4 mb-2 d-flex flex-column align-items-start gap-2 inputs">
                        <label htmlFor="city">City</label>
                        <input value={selectedWorker?.city} name="city" onChange={handleChange} id="city" />
                     </div>
                     <div className="col-12 col-sm-6 col-md-4 mb-2 d-flex flex-column align-items-start gap-2 inputs">
                        <label htmlFor="pin_code">Pincode</label>
                        <input value={selectedWorker?.pin_code} name="pin_code" onChange={handleChange} id="pin_code" />
                     </div>

                     <div className="col-12 col-sm-6 col-md-4 mb-2 d-flex flex-column align-items-start gap-2 inputs">
                        <label htmlFor="lat">Latitude</label>
                        <input value={selectedWorker?.lat} name="lat" onChange={handleChange} id="latitude" />
                     </div>
                     <div className="col-12 col-sm-6 col-md-4 mb-2 d-flex flex-column align-items-start gap-2 inputs">
                        <label htmlFor="long">Longitude</label>
                        <input value={selectedWorker?.long} name="long" onChange={handleChange} id="longitude" />
                     </div>

                     {
                        selectedWorker?.alternate_number ?
                           <div className="col-12 col-sm-6 col-md-4 mb-2 d-flex flex-column align-items-start gap-2 inputs">
                              <label htmlFor="alternate_number">Alternative Number</label>
                              <input value={selectedWorker?.alternate_number} name="alternate_number" onChange={(e) => handlePhone(e, "alt_number")} id="alternate_number" />
                           </div> : ""
                     }
                     {/* {
                        selectedWorker?.worker_type !== ECategory?.BUSINESS_FIRM ?
                           <div className="col-12 col-sm-6 col-md-4 mb-2 d-flex flex-column align-items-start gap-2 inputs">
                              <label htmlFor="date_of_birth">Dob</label>
                              <input value={selectedWorker?.date_of_birth} name="date_of_birth" onChange={handleChange} id="date_of_birth" />
                           </div> : ''
                     } */}

                     <div className="col-12 col-sm-6 col-md-4 mb-2 d-flex flex-column align-items-start gap-2 inputs">
                        <label htmlFor="account_holder_name">Account Holder Name</label>
                        <input value={selectedWorker?.account_holder_name} name="account_holder_name" onChange={handleChange} id="account_holder_name" />
                     </div>
                     <div className="col-12 col-sm-6 col-md-4 mb-2 d-flex flex-column align-items-start gap-2 inputs">
                        <label htmlFor="bank_name">Bank Name</label>
                        <input value={selectedWorker?.bank_name} name="bank_name" onChange={handleChange} id="bank_name" />
                     </div>
                     <div className="col-12 col-sm-6 col-md-4 mb-2 d-flex flex-column align-items-start gap-2 inputs">
                        <label htmlFor="account_number">Account Number</label>
                        <input value={selectedWorker?.account_number} name="account_number" onChange={handleChange} id="account_number" />
                     </div>

                     <div className="col-12 col-sm-6 col-md-4 mb-2 d-flex flex-column align-items-start gap-2 inputs">
                        <label htmlFor="IFSC_code">IFSC Code</label>
                        <input value={selectedWorker?.IFSC_code} name="IFSC_code" onChange={handleChange} id="IFSC_code" />
                     </div>
                     {
                        selectedWorker?.worker_type !== ECategory?.SELLER ?
                           <>
                              <div className="col-12 col-sm-6 col-md-4 mb-2 d-flex flex-column align-items-start gap-2 inputs">
                                 {/** Determine the field name dynamically */}
                                 {(() => {
                                    const isFirm = selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM || selectedWorker?.has_firm;
                                    const fieldName = isFirm ? "firm_gst_number" : "adhaar_number";
                                    const fieldLabel = isFirm ? "Firm Gst Number" : "Aadhar Number";

                                    return (
                                       <>
                                          <label htmlFor={fieldName}>{fieldLabel}</label>
                                          <input
                                             value={selectedWorker?.[fieldName] || ""}
                                             name={fieldName}
                                             id={fieldName}
                                             onChange={handleChange}
                                          />
                                       </>
                                    );
                                 })()}
                              </div>

                              <div className="col-12 col-sm-6 col-md-4 mb-2 d-flex flex-column align-items-start gap-2 inputs">
                                 {/** Determine the field name dynamically */}
                                 {(() => {
                                    const isFirm = selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM || selectedWorker?.has_firm;
                                    const fieldName = isFirm ? "firm_pan_number" : "pan_number";
                                    const fieldLabel = isFirm ? "Firm Pan Number" : "Pan Number";

                                    return (
                                       <>
                                          <label htmlFor={fieldName}>{fieldLabel}</label>
                                          <input
                                             value={selectedWorker?.[fieldName] || ""}
                                             name={fieldName}
                                             id={fieldName}
                                             onChange={handleChange}
                                          />
                                       </>
                                    );
                                 })()}
                              </div>
                           </> : ''
                     }


                     {/* <div className="col-12 col-sm-6 col-md-4 mb-2 d-flex flex-column align-items-start gap-2 inputs">
                        <label
                           htmlFor="pan_number">
                           {`${(selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM || selectedWorker?.has_firm) ? "Firm Pan Number" : "Pan Number"} `}
                        </label>
                        <input value={selectedWorker?.pan_number} name="pan_number" onChange={handleChange} id="pan_number" />
                     </div> */}


                     <div className="inputs mb-2  col-6 col-md-4">
                        <div className="d-flex flex-column align-items-start gap-2 gap-2">
                           <label htmlFor="is_otp_verified">Has Membership</label>
                           <div className="d-flex gap-4">
                              <div className="d-flex gap-2">
                                 <Checkbox type={selectedWorker?.has_membership} id={"has_membership"} name={"has_membership"} onChange={(event) => setSelectedWorker({ ...selectedWorker, has_membership: event.target.checked })} />
                                 <span>Yes</span>
                              </div>
                           </div>
                        </div>
                     </div>

                     <div className="inputs mb-2  col-6 col-md-4">
                        <div className="d-flex flex-column align-items-start gap-2 gap-2">
                           <label htmlFor="is_otp_verified">Activated Account</label>
                           <div className="d-flex gap-4">

                              <div className="d-flex gap-2">
                                 <Checkbox type={selectedWorker?.is_activated_account} id={"is_activated_account"} name={"is_activated_account"} onChange={(event) => setSelectedWorker({ ...selectedWorker, is_activated_account: event.target.checked })} />
                                 <span>Active</span>
                              </div>
                           </div>
                        </div>
                     </div>

                     <div className="inputs mb-2  col-6 col-md-4">
                        <div className="d-flex flex-column align-items-start gap-2 gap-2">
                           <label htmlFor="is_otp_verified">Basic Details Completed</label>
                           <div className="d-flex gap-4">

                              <div className="d-flex gap-2">
                                 <Checkbox type={selectedWorker?.is_basic_details_completed} id={"is_basic_details_completed"} name={"is_basic_details_completed"} onChange={(event) => setSelectedWorker({ ...selectedWorker, is_basic_details_completed: event.target.checked })} />
                                 <span>Completed</span>
                              </div>
                           </div>
                        </div>
                     </div>

                     <div className="inputs mb-2  col-6 col-md-4">
                        <div className="d-flex flex-column align-items-start gap-2 gap-2">
                           <label htmlFor="is_otp_verified">Completed document Details</label>
                           <div className="d-flex gap-4">

                              <div className="d-flex gap-2">
                                 <Checkbox type={selectedWorker?.is_document_details_completed} id={"is_document_details_completed"} name={"is_document_details_completed"} onChange={(event) => setSelectedWorker({ ...selectedWorker, is_document_details_completed: event.target.checked })} />
                                 <span>Yes</span>
                              </div>
                           </div>
                        </div>
                     </div>

                     <div className="inputs mb-2  col-6 col-md-4">
                        <div className="d-flex flex-column align-items-start gap-2 gap-2">
                           <label htmlFor="is_basic_details_completed">Is Online</label>
                           <div className="d-flex gap-4">

                              <div className="d-flex gap-2">
                                 <Checkbox type={selectedWorker?.is_online} id={"is_online"} name={"is_online"} onChange={(event) => setSelectedWorker({ ...selectedWorker, is_online: event.target.checked })} />
                                 <span>Yes</span>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className="inputs mb-2  col-6 col-md-4">
                        <div className="d-flex flex-column align-items-start gap-2 gap-2">
                           <label htmlFor="is_basic_details_completed">Is Otp Verified</label>
                           <div className="d-flex gap-4">

                              <div className="d-flex gap-2">
                                 <Checkbox type={selectedWorker?.is_otp_verified} id={"is_otp_verified"} name={"is_otp_verified"} onChange={(event) => setSelectedWorker({ ...selectedWorker, is_otp_verified: event.target.checked })} />
                                 <span>Verified</span>
                              </div>
                           </div>
                        </div>
                     </div>
                     {
                        (selectedWorker?.worker_type !== ECategory.SALES_PROFESSIONAL) ?
                           <div className="inputs mb-2  col-6 col-md-4">
                              <div className="d-flex flex-column align-items-start gap-2 gap-2">
                                 <label htmlFor="is_basic_details_completed">Is Worker Verified</label>
                                 <div className="d-flex gap-4">

                                    <div className="d-flex gap-2">
                                       <Checkbox type={selectedWorker?.is_verified} id={"is_verified"} name={"is_verified"} onChange={(event) => setSelectedWorker({ ...selectedWorker, is_verified: event.target.checked })} />
                                       <span>Verified</span>
                                    </div>
                                 </div>
                              </div>
                           </div> : ""
                     }


                     {
                        (selectedWorker?.worker_type !== ECategory.SALES_PROFESSIONAL)
                           && (selectedWorker?.worker_type !== ECategory.BUSINESS_FIRM) ?
                           <div className="inputs mb-2  col-6 col-md-4">
                              <div className="d-flex flex-column align-items-start gap-2 gap-2">
                                 <label htmlFor="is_basic_details_completed">Question & Answers</label>
                                 <div className="d-flex gap-4">

                                    <div className="d-flex gap-2">
                                       <Checkbox type={selectedWorker?.is_question_ans_completed} id={"is_question_ans_completed"} name={"is_question_ans_completed"} onChange={(event) => setSelectedWorker({ ...selectedWorker, is_question_ans_completed: event.target.checked })} />
                                       <span>Completed</span>
                                    </div>
                                 </div>
                              </div>
                           </div> : ""
                     }

                  </div>
                  <div className="row">
                     <div className=" mb-2 col-12 col-sm-6 col-md-4 col-lg-3">
                        <div className="d-flex flex-column align-items-start gap-2 ">
                           <label htmlFor="profile_pic">Profile Pic</label>
                           <div className="d-flex align-items-center edit-image w-80">
                              <img
                                 src={
                                    selectedWorker?.profile_pic
                                       ? typeof selectedWorker.profile_pic === 'string'
                                          ? selectedWorker.profile_pic
                                          : URL.createObjectURL(selectedWorker.profile_pic)
                                       : profileIcon
                                 }
                                 alt="profile_pic"
                              />
                              <div className="edit-icon">
                                 <img src={edit} alt="edit-icon" />
                                 <input type="file" id="profile_pic" name="profile_pic" accept="image/png, image/jpeg, image/jpg"
                                    onChange={handleFileChange} />
                              </div>

                           </div>
                        </div>
                     </div>

                     {
                        selectedWorker?.worker_type === ECategory?.SELLER ?
                           <>
                              <div className=" mb-2 col-12 col-sm-6 col-md-4 col-lg-3">
                                 <div className="d-flex flex-column align-items-start gap-2  ">
                                    <label htmlFor="seller_shop_pic1">
                                       Shop Image 1

                                    </label>
                                    <div className="d-flex align-items-center edit-image w-80">

                                       <img
                                          src={
                                             selectedWorker?.seller_shop_pic1
                                                ? typeof selectedWorker.seller_shop_pic1 === 'string'
                                                   ? selectedWorker.seller_shop_pic1
                                                   : URL.createObjectURL(selectedWorker.seller_shop_pic1)
                                                : placeholderImg
                                          }
                                          alt="seller_shop_pic1"
                                       />


                                       <div className="edit-icon">
                                          <img src={edit} alt="edit-icon" />
                                          <input type="file"
                                             id="seller_shop_pic1"
                                             name="seller_shop_pic1"
                                             accept="image/png, image/jpeg, image/jpg"
                                             onChange={handleFileChange} />
                                       </div>

                                    </div>

                                 </div>
                              </div>

                              <div className=" mb-2 col-12 col-sm-6 col-md-4 col-lg-3">
                                 <div className="d-flex flex-column align-items-start gap-2  ">
                                    <label htmlFor="seller_shop_pic2">
                                       Shop Image 2

                                    </label>
                                    <div className="d-flex align-items-center edit-image w-80">

                                       <img
                                          src={
                                             selectedWorker?.seller_shop_pic2
                                                ? typeof selectedWorker.seller_shop_pic2 === 'string'
                                                   ? selectedWorker.seller_shop_pic2
                                                   : URL.createObjectURL(selectedWorker.seller_shop_pic2)
                                                : placeholderImg
                                          }
                                          alt="seller_shop_pic2"
                                       />


                                       <div className="edit-icon">
                                          <img src={edit} alt="edit-icon" />
                                          <input type="file"
                                             id="seller_shop_pic2"
                                             name="seller_shop_pic2"
                                             accept="image/png, image/jpeg, image/jpg"
                                             onChange={handleFileChange} />
                                       </div>

                                    </div>

                                 </div>
                              </div>
                           </>
                           :
                           <>
                              <div className=" mb-2 col-12 col-sm-6 col-md-4 col-lg-3">
                                 <div className="d-flex flex-column align-items-start gap-2  ">
                                    <label
                                       htmlFor={`${(selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM || selectedWorker?.has_firm) ? "firm_gst_pic" : "adhaar_front_pic"} `}>
                                       {`${(selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM || selectedWorker?.has_firm) ? "Firm Gst Image" : " Aadhar Front"} `}

                                    </label>
                                    <div className="d-flex align-items-center edit-image w-80">
                                       {(selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM || selectedWorker?.has_firm) ?
                                          <img
                                             src={
                                                selectedWorker?.firm_gst_pic
                                                   ? typeof selectedWorker.firm_gst_pic === 'string'
                                                      ? selectedWorker.firm_gst_pic
                                                      : URL.createObjectURL(selectedWorker.firm_gst_pic)
                                                   : placeholderImg
                                             }
                                             alt="firm_gst_pic"
                                          /> :
                                          <img
                                             src={
                                                selectedWorker?.adhaar_front_pic
                                                   ? typeof selectedWorker.adhaar_front_pic === 'string'
                                                      ? selectedWorker.adhaar_front_pic
                                                      : URL.createObjectURL(selectedWorker.adhaar_front_pic)
                                                   : placeholderImg
                                             }
                                             alt="adhaar_front_pic"
                                          />
                                       }

                                       <div className="edit-icon">
                                          <img src={edit} alt="edit-icon" />
                                          <input type="file"
                                             id={`${(selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM || selectedWorker?.has_firm) ? "firm_gst_pic" : "adhaar_front_pic"} `}
                                             name={`${(selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM || selectedWorker?.has_firm) ? "firm_gst_pic" : "adhaar_front_pic"} `}
                                             accept="image/png, image/jpeg, image/jpg"
                                             onChange={handleFileChange} />
                                       </div>

                                    </div>

                                 </div>
                              </div>

                              <div className=" mb-2 col-12 col-sm-6 col-md-4 col-lg-3">
                                 <div className="d-flex flex-column align-items-start gap-2 ">
                                    <label
                                       htmlFor={`${(selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM || selectedWorker?.has_firm) ? "firm_gst_pic" : "adhaar_front_pic"} `}>
                                       {`${(selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM || selectedWorker?.has_firm) ? "Firm Pan Image" : "Aadhar Back Image"} `}</label>
                                    <div className="d-flex align-items-center edit-image w-80">
                                       {(selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM || selectedWorker?.has_firm) ?
                                          <img
                                             src={
                                                selectedWorker?.firm_pan_pic
                                                   ? typeof selectedWorker.firm_pan_pic === 'string'
                                                      ? selectedWorker.firm_pan_pic
                                                      : URL.createObjectURL(selectedWorker.firm_pan_pic)
                                                   : placeholderImg
                                             }
                                             alt="firm_pan_pic"
                                          /> :
                                          <img
                                             src={
                                                selectedWorker?.adhaar_back_pic
                                                   ? typeof selectedWorker.adhaar_back_pic === 'string'
                                                      ? selectedWorker.adhaar_back_pic
                                                      : URL.createObjectURL(selectedWorker.adhaar_back_pic)
                                                   : placeholderImg
                                             }
                                             alt="adhaar_back_pic"
                                          />
                                       }

                                       <div className="edit-icon">
                                          <img src={edit} alt="edit-icon" />

                                          <input type="file" id={`${(selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM || selectedWorker?.has_firm) ? "firm_gst_pic" : "adhaar_front_pic"} `}
                                             name={`${(selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM || selectedWorker?.has_firm) ? "firm_gst_pic" : "adhaar_front_pic"} `}
                                             accept="image/png, image/jpeg, image/jpg"
                                             onChange={handleFileChange} />
                                       </div>

                                    </div>


                                 </div>
                              </div>
                              {
                                 (selectedWorker?.worker_type !== ECategory?.BUSINESS_FIRM && !selectedWorker?.has_firm) ?
                                    <div className=" mb-2 col-12 col-sm-6 col-md-4 col-lg-3">
                                       <div className="d-flex flex-column align-items-start gap-2 ">
                                          <label htmlFor="pan_front_pic">Pan Card Image</label>
                                          <div className="d-flex align-items-center edit-image w-80">
                                             <img
                                                src={
                                                   selectedWorker?.pan_front_pic
                                                      ? typeof selectedWorker.pan_front_pic === 'string'
                                                         ? selectedWorker.pan_front_pic
                                                         : URL.createObjectURL(selectedWorker.pan_front_pic)
                                                      : placeholderImg
                                                }
                                                alt="pan_front_pic"
                                             />
                                             <div className="edit-icon">
                                                <img src={edit} alt="edit-icon" />
                                                <input type="file" id="pan_front_pic" name="pan_front_pic" accept="image/png, image/jpeg, image/jpg"
                                                   onChange={handleFileChange} />
                                             </div>

                                          </div>

                                       </div>
                                    </div> : ""
                              }

                           </>

                     }


                  </div>

                  {
                     loading ? <LoadingGif /> : ""
                  }

                  {/* button down */}
                  <div className="col-md-12 d-flex  align-items-center justify-content-between pt-4">
                     <button type="button" className="btn btn-dark" onClick={() => {
                        navigate(-1)
                     }}>Back</button>
                     <button type="submit" className="btn btn-primary"
                        onClick={() => dispatch(startLoading())}
                     >{loading ? "Loading..." : "Update"}</button>

                  </div>

               </form>
            </div>
         </div>
      </MainLayout>
   )
}

export default WorkerEditPage;